import { push } from "connected-react-router";
import { put } from "redux-saga/effects";

export default function* forwardTo(location) {
	yield put(push(location));
}
